import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import SkeltonElement from "../../../../components/commons/SkeltonLoader/SkeltonElement";
import { RootState } from "../../../../redux/rootReducers";
import { InvoiceCountGraphDataType } from "../../../../redux/listing/listingTypes";
import Select from "react-select";
import { ClientType } from "../../../../redux/auth/authTypes";
import { getClientDirectoryListAction } from "../../../../redux/clientDirectory";
import useDebounce from "../../../../customHooks/useDebounce";
import InvoiceCounteHeader from "../../../../components/AdminReports/AdvanceInvoiceCount/InvoiceCountHeader";
import { Col } from "reactstrap";
import { calculateDate } from "../../../../utils/commonFunctions";

type clientListType = {
  value: number | undefined;
  label: string | undefined;
};
type getAllClientPayload = {
  token: string;
  offset: number;
  limit: number;
  searchValue: string | undefined;
};
type DropDown = {
  label: string;
  value: string;
};

type AppProps = {
  changeYear?: any;
  handleDropChange: (e: DropDown) => void;
  monthlyGraphData: InvoiceCountGraphDataType[] | [];
  clientSelected: any;
  handleChangeClient: (client: any) => void;
  clientList: ClientType[] | [];
  totalClientsCount: any;
  token: string | null;
  fetching: boolean;
  dispatchGetAllClientAction: (data: getAllClientPayload) => void;
  dispatchResetInvoiceGraphData: () => void;
  startDate: any;
  endDate: any;
  financialYear: any;
};

const InvoiceCountMonthlyGraph = ({
  changeYear,
  handleDropChange,
  monthlyGraphData,
  clientSelected,
  handleChangeClient,
  clientList,
  totalClientsCount,
  dispatchGetAllClientAction,
  token,
  fetching,
  startDate,
  endDate,
  financialYear,
}: AppProps) => {
  const [period, setPeriod] = useState<any[]>([]);
  const [expenseCount, setExpenseCount] = useState<any[]>([]);
  const [salesCount, setSalesCount] = useState<any[]>([]);
  const [othersCount, setOthersCount] = useState<any[]>([]);
  const [manufacturingCount, setManufacturingCount] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<any[]>([]);
  const [loadCondition, setLoadCondition] = useState(true);
  const [offset, setoffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [finalClientList, setFinalClientList] = useState<clientListType[]>([]);
  const [text, setText] = useState<string>("");
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  useEffect(() => {
    const periodData = monthlyGraphData?.map((item: any) => item.period);
    setPeriod(periodData);

    const expenseData = monthlyGraphData?.map(
      (item: any) => item.expenses_count
    );
    setExpenseCount(expenseData);

    const salesData = monthlyGraphData?.map((item: any) => item.revenues_count);
    setSalesCount(salesData);

    const othersData = monthlyGraphData?.map((item: any) => item.others_count);
    setOthersCount(othersData);

    const manufacturingData = monthlyGraphData?.map(
      (item: any) => item.manufacturing_count
    );
    setManufacturingCount(manufacturingData);

    const totalData = monthlyGraphData?.map((item: any) => item.total);
    setTotalCount(totalData);
  }, [monthlyGraphData]);

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setoffset((prv) => prv + limit);
  };
  useDebounce(
    () => {
      if (isApiCall) {
        fetchNewData(text);
      }
    },
    500,
    [text]
  );
  useEffect(() => {
    if (clientList?.length > 0) {
      if (offset <= +totalClientsCount) {
        let finalClientData = clientList?.map((user: any) => {
          return {
            value: user.client_code,
            label: `${user.company_name} (${user.client_code})`,
          };
        });
        if (offset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientList]);

  useEffect(() => {
    if (token) {
      if (offset <= +totalClientsCount) {
        let finalClientData = {
          token,
          offset,
          limit,
          searchValue: text,
        };
        dispatchGetAllClientAction(finalClientData);
        setIsApiCall(true);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
      };
      dispatchGetAllClientAction(finalData);
    }
  };

  const option = {
    tooltip: {
      trigger: "axis",
    },

    xAxis: [
      {
        data: period?.length === 0 ? [] : period,
        nameLocation: "middle",
        nameTextStyle: {
          width: 100,
          color: "#4e4b66",
          fontSize: "14px",
        },
        nameGap: 15,
      },
    ],

    yAxis: [
      {
        type: "value",
        scale: "true",
        nameLocation: "middle",
        nameTextStyle: {
          color: "#4e4b66",
          fontSize: "14px",
          fontFamily: "Poppins",
        },
        nameGap: 25,
      },
    ],

    series: [
      {
        name: "expense",
        type: "bar",
        cursor: "default",
        symbol: "none",
        smooth: 0.2,
        barWidth: "15%",
        itemStyle: {
          color: "#fc8452",
        },
        data: expenseCount?.length === 0 ? [] : expenseCount,
      },
      {
        name: "sales",
        type: "bar",
        cursor: "default",
        smooth: 0.2,
        symbol: "none",
        barWidth: "15%",
        itemStyle: {
          color: "#3ba272",
        },
        data: salesCount?.length === 0 ? [] : salesCount,
      },
      {
        name: "others",
        type: "bar",
        cursor: "default",
        smooth: 0.2,
        symbol: "none",
        barWidth: "15%",
        itemStyle: {
          color: "#5470c6",
        },
        data: othersCount?.length === 0 ? [] : othersCount,
      },
      {
        name: "manufacturing",
        type: "bar",
        cursor: "default",
        smooth: 0.2,
        symbol: "none",
        barWidth: "15%",
        itemStyle: {
          color: "#73c0de",
        },
        data: manufacturingCount?.length === 0 ? [] : manufacturingCount,
      },
      {
        name: "total invoice count",
        type: "line",
        cursor: "default",
        smooth: 0.2,
        symbol: "circle",
        symbolSize: 10,
        lineStyle: {
          color: "#e7ae30",
          width: 2.5,
        },
        itemStyle: {
          color: "#e7ae30",
        },
        data: totalCount?.length === 0 ? [] : totalCount,
      },
    ],
  };

  return (
    <>
      {fetching ? (
        <SkeltonElement type="XXLavatar" />
      ) : (
        <>
          <div className="mt-2">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="ml-3" style={{ display: "flex" }}>
                <div style={{ fontSize: "18px", fontWeight: 500 }}>
                  Invoice Count Summary
                </div>
              </div>
              <Col lg={5} className="d-flex flex-row justify-content-end mt-3">
                {
                  <div className="mr-3 ">
                    <InvoiceCounteHeader
                      changeYear={changeYear}
                      handleDropChange={handleDropChange}
                    />
                  </div>
                }
                {
                  <div className="mr-3 " style={{ width: "150px" }}>
                    <Select
                      options={[
                        { label: "All Client", value: null },
                        ...finalClientList,
                      ]}
                      value={clientSelected}
                      cacheOptions
                      onChange={handleChangeClient}
                      onMenuScrollToBottom={(e: any) => checkBottom(e)}
                      onInputChange={(e: string) => {
                        setLoadCondition(false);
                        setText(e);
                        setoffset(0);
                      }}
                      // onMenuClose={onMenuClose}
                      isLoading={!loadCondition && fetching}
                    />
                  </div>
                }
              </Col>
            </div>
            <div className="d-flex flex-column ">
              <div className="d-flex justify-content-center mt-3 flex-column">
                <div className="d-flex flex-row justify-content-center">
                  <h4>{clientSelected?.label}</h4>
                </div>
                {monthlyGraphData?.length ? (
                  <div>
                  <div className="d-flex flex-row justify-content-center">
                    <h4 className="text-center mr-4" style={{ fontSize: "12px" }}>
                      Start Date:{" "}
                      <span
                        className="font-weight-bolder"
                        style={{ fontSize: "12px" }}
                      >
                        {startDate}
                      </span>
                    </h4>
                    <h4 className="text-center" style={{ fontSize: "12px" }}>
                      End Date:{" "}
                      <span
                        className="font-weight-bolder"
                        style={{ fontSize: "12px" }}
                      >
                        {endDate}
                      </span>
                    </h4>
                  </div>
                  {changeYear?.value?.split("-")[1] ===
                  financialYear?.split("-")[1] || changeYear?.label === "Last 3 Months" || changeYear?.label === "Last 6 Months" ? (
                    <h6
                      className="text-center"
                      style={{ color: "#dd4433", fontSize: "12px" }}
                    >
                      As of Previous Date: {calculateDate()}
                    </h6>
                  ) : (
                    ""
                  )}
                  </div>
                ) : ("")}
                
                
              </div>
            </div>
            <div
              style={{
                fontSize: "15px",
                justifyContent: "left",
                alignItems: "center",
                margin: "20px 0px 0px 45px",
              }}
              className="d-flex mt-3 mb-2"
            >
              <div
                className="mr-2"
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "#fc8452",
                }}
              ></div>
              &nbsp;
              <span>Expense</span>
              &nbsp;
              <div
                className="ml-5"
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "#3ba272",
                }}
              ></div>
              &nbsp;
              <span className="ml-2">Sales</span>
              <div
                className="ml-5"
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "#5470c6",
                }}
              ></div>
              &nbsp;
              <span className="ml-2">Others</span>
              <div
                className="ml-5"
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "#73c0de",
                }}
              ></div>
              &nbsp;
              <span className="ml-2">Manufacturing</span>
              <div
                className="ml-5"
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "#e7ae30",
                }}
              ></div>
              &nbsp;
              <span className="ml-2">Total Invoice Count</span>
            </div>

            <ReactECharts
              option={option}
              style={{
                width: "100%",
                position: "relative",
                top: "10%",
                bottom: "10%",
              }}
            />
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.clientDirectory.clientDirectoryList,
  totalClientsCount: state.clientDirectory.totalCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllClientAction: (data: getAllClientPayload) =>
    dispatch(getClientDirectoryListAction(data)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceCountMonthlyGraph);
